import React, { useContext } from "react";

import { ThemingContext } from "../../hoc/Theming/Theming";

import "./Checkbox.scss";

const Checkbox = (props) => {
  const styling = useContext(ThemingContext);

  return (
    <label
      className="checkbox"
      style={{
        fontWeight: props.fontWeight ? props.fontWeight : "400",
        fontSize: props.fontSize ? props.fontSize : "14px",
      }}
    >
      <input
        type="checkbox"
        checked={props.checked}
        onChange={props.changed}
        required={props.required}
        disabled={props.disabled}
      />
      {props.children}
      <span
        className={`checkmark ${props.disabled && `check-disabled`}`}
        style={
          !props.disabled
            ? props.checked
              ? styling.component.checkbox.checked
              : styling.component.checkbox.checkmark
            : null
        }
      />
    </label>
  );
};

export default Checkbox;

// Props

// checked: Bool
// onChange: func
// required: Bool
